import { ReactElement } from 'react';
import styled from 'styled-components';
import { paletteHelper } from '@construct-kit/core';
import REASiteLinks from './REASiteLinks';
import NavigationLinks from './NavigationLinks';

const FooterContainer = styled.footer`
  border-top: 1px solid ${paletteHelper('backgroundSecondaryBase')};
`;

const Footer = (): ReactElement => (
  <FooterContainer>
    <NavigationLinks />
    <REASiteLinks />
  </FooterContainer>
);

export default Footer;
